<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        v-bind:width="width"
        v-bind:height="height"
        v-bind:aria-labelledby="uniqueId"
        v-bind:viewBox="viewBox"
        role="presentation"
    >
        <title v-bind:id="uniqueId" lang="en">
            {{ title }}
        </title>
        <g v-bind:fill="iconColor">
            <slot></slot>
        </g>
    </svg>
</template>

<script>
    import _uniqueId from 'lodash/uniqueId';

    export default {
        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            height: {
                type: [
                    Number,
                    String,
                ],
                default: 'auto',
            },
            iconColor: {
                type: String,
                default: 'currentColor',
            },
            title: {
                type: String,
                default: 'Icon',
            },
            viewBox: {
                type: String,
                default: '0 0 36 36',
            },
            width: {
                type: [
                    Number,
                    String,
                ],
                default: '100%',
            },
        },

        /**
         * This method logic will be run immediately after the Vue instance is created.
         *
         * @link https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
         */
        created () {
            this.uniqueId = _uniqueId('svg-icon-title-');
        },
    };
</script>
